import React from 'react'
import { useRecoilState } from 'recoil'
import { useIntl } from 'react-intl'

import {
  InputTextArea,
  Panel,
  FormElement,
  Flex,
  Link,
  LINK_VARIANT_HIGHLIGHT,
  SpacingVertical,
  SPACING_8,
  SPACING_16,
  FontAwesomeIcon
} from 'mailup-web-components'

import { messageState } from '../recoil/state/message'

const InputPlainText = () => {
  const intl = useIntl()

  const [{ plainText }, setPlainText] = useRecoilState(messageState)

  const handleChangeText = e => {
    setPlainText(prev => ({
      ...prev,
      plainText: e.target.value,
      isDirty: true
    }))
  }

  const handleAddUnsubscribe = () => {
    setPlainText(prev => ({
      ...prev,
      plainText: prev.plainText.concat('\n<http://[unsubscribe]/>'),
      isDirty: true
    }))
  }

  const handleAddUntrack = () => {
    setPlainText(prev => ({
      ...prev,
      plainText: prev.plainText.concat('\n<http://[donottrack]/>'),
      isDirty: true
    }))
  }

  return (
    <Panel>
      <SpacingVertical variant={SPACING_8} />
      <FormElement
        label={intl.formatMessage({ id: 'Load.EmailCheckUp.TextVersionTab' })}
      >
        <InputTextArea
          placeholder={intl.formatMessage({
            id: 'Load.EmailCheckUp.PlainTextVersionPlaceholder'
          })}
          value={plainText}
          onChange={handleChangeText}
          rows={20}
          data-mu-test='input-text-area__input-plain-text'
        />
      </FormElement>
      <SpacingVertical variant={SPACING_16} />
      <Flex gap='16px'>
        <Link
          variant={LINK_VARIANT_HIGHLIGHT}
          onClick={handleAddUnsubscribe}
          data-mu-test='unsubscribe-btn'
        >
          <Flex gap='4px' alignItems='baseline'>
            <FontAwesomeIcon icon='plus' />
            {intl.formatMessage({
              id: 'Load.EmailCheckUp.PlainTextVersionLinkUnsubscribeBtn'
            })}
          </Flex>
        </Link>
        <Link
          variant={LINK_VARIANT_HIGHLIGHT}
          onClick={handleAddUntrack}
          data-mu-test='untrack-btn'
        >
          <Flex gap='4px' alignItems='baseline'>
            <FontAwesomeIcon icon='plus' />
            {intl.formatMessage({
              id: 'Load.EmailCheckUp.PlainTextVersionLinkDisableTrackingBtn'
            })}
          </Flex>
        </Link>
      </Flex>
      <SpacingVertical variant={SPACING_8} />
    </Panel>
  )
}

export default InputPlainText
